import { Helmet } from "react-helmet";
import type { FAQItem } from "./faq-types";

export function FAQSchema({ items }: { items: FAQItem[] }) {
  if (!items.length) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: items.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.answerText,
            },
          })),
        })}
      </script>
    </Helmet>
  );
}